export const rules = {
  manageRulesPara:
    'Edytuj, usuń lub dodawaj reguły. Reguły pozwalają na dynamiczne sterowanie widocznością opcji oraz sterowaniwanie zachowaniem modelu w zależności od wybranych przez użytkownika parametrów.',
  rules: 'Reguły',
  add: 'Dodaj regułę',
  noRules: 'Brak reguł utworzonych dla opcji',
  createFirstRule: 'Utwórz pierwszą regułę',
  deleteRuleTitle: 'Czy na pewno chcesz usunąć tę regułę',
  deletedSuccess: 'Usunięto regułę',
  editRule: 'Edytuj regułę',
  deleteRule: 'Usuń regułę',
  displayRule: 'Podgląd reguły',
  previewRule: 'Podejrzyj regułę',
  filterPlaceholder: 'Filtruj wg.',
  filterPlaceholderText: 'Filtruj wg. typu',
  filters: {
    all: 'Wszystko',
    option: 'Opcja',
    group: 'Grupa',
    step: 'Krok',
    full: 'Pełna fraza',
  },
} as const
